module.exports = __webpack_public_path__ + "img/promotion-bg.f2df96bd.png";